import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Spinner, Modal, Card } from "react-bootstrap";
import { ArrowLeft, ShoppingCart } from "react-feather";

import CartItems from "./_cartItems";
import CartSummary from "./_summary";

import { useAuth } from "../../contexts/authContext";
import { useNotification } from "../../components/notification";
import apiService from "../../services/apiService";

import { cartSession } from "../../utils/cart";

const Cart = () => {
  const { isAuthenticated } = useAuth();
  const { showNotification } = useNotification();
  const didFetch = useRef(false);

  const [cart, setCart] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [couponCode, setCouponCode] = useState("");

  useEffect(() => {
    if (didFetch.current) return; // Prevent second call
    didFetch.current = true;

    const fetchCart = async () => {
      try {
        const apiURL = isAuthenticated
          ? `/cart/${cartSession.get("cartId")}`
          : `/cart?sessionId=${cartSession.get()}`;
        const response = await apiService.get(apiURL);
        setCart(response);
      } catch (error) {
        console.error("Error fetching cart:", error);
      } finally {
        setIsPageLoading(false);
      }
    };

    fetchCart();
  }, [isAuthenticated]);

  if (!cart || Object.keys(cart).length === 0 || cart?.CartItems.length === 0) {
    return (
      <Row className="justify-content-center">
        <Col xs={"auto"} className="text-center">
          <Card className="mt-5 mb-4 p-5">
            <ShoppingCart size={32} className="text-light-emphasis m-auto" />
            <h5 className="mt-3">Your cart is empty</h5>
            <p className="text-muted mb-0">
              Looks like you haven't added any products to your cart yet.
            </p>
          </Card>
          <Link to="/" className="link-secondary">
            <ArrowLeft size={16} className="me-1" />
            BACK TO SHOP
          </Link>
        </Col>
      </Row>
    );
  }

  return (
    <Container className="cart">
      <Row>
        <Col xs={12}>
          <h1 className="h4 text-center my-4">Cart</h1>
        </Col>
        <Col lg={8} xl={9}>
          <CartItems
            cart={cart}
            setCart={setCart}
            showNotification={showNotification}
            isAuthenticated={isAuthenticated}
            sessionId={cartSession.get()}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
          />
        </Col>
        <Col lg={4} xl={3}>
          <Card className="bg-light p-3 rounded-3 border-0 mt-4 mt-lg-0">
            <CartSummary cart={cart} />
            <Link
              to="/checkout"
              state={{ couponCode }}
              className="w-100 mt-4 btn btn-primary btn-main"
            >
              CHECKOUT
            </Link>
            <Link to="/" className="w-100 mt-2 btn btn-dark btn-main">
              BACK TO SHOP
            </Link>
          </Card>
        </Col>
      </Row>
      <Modal
        show={isPageLoading}
        aria-labelledby="Loading"
        className="modal-loading"
        contentClassName="bg-transparent border-0"
        centered
      >
        <Modal.Body className="text-center">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Cart;
